(function () {
  'use strict';
  var STORAGE_PENDING = 'comuSubscribePendingEmail';
  var STORAGE_KNOWN = 'comuSubscribeKnownEmails';
  function escapeHtml(text) {
    var node = document.createElement('div');
    node.textContent = text;
    return node.innerHTML;
  }
  function buildBanner(status, text) {
    var icon =
      status === 'success'
        ? '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="currentColor" opacity="0.15"></circle><path d="M5.5 9.2l2.2 2.2 5.1-5.4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
        : '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="currentColor" opacity="0.15"></circle><path d="M9 5v5M9 12.5h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>';
    return (
      '<div class="banner banner--' +
      status +
      ' justify-center" role="alert" aria-live="polite">' +
      icon +
      escapeHtml(text) +
      '</div>'
    );
  }
  function hasCustomerPostedParam() {
    try {
      return new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    } catch (error) {
      return /[?&]customer_posted=true(?:&|$)/.test(window.location.search);
    }
  }
  function readKnownEmails() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KNOWN);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  function writeKnownEmails(list) {
    try {
      window.localStorage.setItem(STORAGE_KNOWN, JSON.stringify(list.slice(-50)));
    } catch (error) {
      /* ignore */
    }
  }
  function isKnownEmail(email) {
    var normalized = String(email || '').trim().toLowerCase();
    if (!normalized) return false;
    return readKnownEmails().indexOf(normalized) !== -1;
  }
  function rememberKnownEmail(email) {
    var normalized = String(email || '').trim().toLowerCase();
    if (!normalized) return;
    var list = readKnownEmails();
    if (list.indexOf(normalized) === -1) {
      list.push(normalized);
      writeKnownEmails(list);
    }
  }
  function moduleAnchorHash(root) {
    if (root.id) return '#' + root.id;
    var parent = root.closest('[id]');
    return parent && parent.id ? '#' + parent.id : '#subscribe';
  }
  function shouldApplyPostedState(root) {
    if (!hasCustomerPostedParam()) return true;
    var hash = window.location.hash;
    if (!hash) return true;
    return hash === moduleAnchorHash(root);
  }
  function initSubscribeModule(root) {
    if (!root || root.dataset.comuSubscribeReady === 'true') return;
    var form = root.querySelector('form[data-comu-subscribe-form]');
    if (!form) return;
    var fields = form.querySelector('[data-comu-subscribe-fields]');
    var successBox = form.querySelector('[data-comu-subscribe-success]');
    var errorBox = form.querySelector('[data-comu-subscribe-error]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    if (!fields || !successBox || !emailInput) return;
    root.dataset.comuSubscribeReady = 'true';
    form.setAttribute('novalidate', 'novalidate');
    var successText =
      root.getAttribute('data-success-text') ||
      'Thanks for subscribing! Product news and launch offers are on the way.';
    var duplicateText =
      root.getAttribute('data-duplicate-text') ||
      "You're already on the list! No need to subscribe again.";
    var invalidEmailText =
      root.getAttribute('data-invalid-email-text') || 'Please enter a valid email address.';
    var consentRequiredText =
      root.getAttribute('data-consent-required-text') || 'Please agree to the Privacy Policy to continue.';
    var consentCheckbox = form.querySelector('[data-comu-subscribe-consent]');
    function setLoading(active) {
      form.classList.toggle('is-submitting', active);
      var submitBtn = form.querySelector('.subscribe-submit, .comulytic-sales__banner-subscribe-submit, .comulytic-sales__dual-cta-subscribe-submit, button[type="submit"]');
      if (submitBtn) {
        /* 只做视觉 loading，不 disable：Shopify Captcha 拿到 token 后会程序化重提，
           disabled 的提交按钮会让 requestSubmit() 直接抛错、流程卡死。 */
        submitBtn.classList.toggle('is-loading', active);
        submitBtn.setAttribute('aria-busy', active ? 'true' : 'false');
      }
    }
    function showSuccess(text) {
      fields.hidden = true;
      successBox.hidden = false;
      successBox.innerHTML = buildBanner('success', text);
      if (errorBox) errorBox.innerHTML = '';
    }
    function showError(message) {
      if (!errorBox) return;
      fields.hidden = false;
      successBox.hidden = true;
      errorBox.innerHTML = buildBanner('error', message);
      setLoading(false);
    }
    function showInvalidEmail() {
      showError(invalidEmailText);
    }
    function applyPostRedirectState() {
      var liquidAlreadySuccess = !successBox.hidden;
      var posted = hasCustomerPostedParam();
      if (!posted && !liquidAlreadySuccess) return;
      if (posted && !shouldApplyPostedState(root)) return;
      var pending = '';
      try {
        pending = window.sessionStorage.getItem(STORAGE_PENDING) || '';
      } catch (error) {
        pending = '';
      }
      var email = (pending || emailInput.value || '').trim().toLowerCase();
      showSuccess(isKnownEmail(email) ? duplicateText : successText);
      rememberKnownEmail(email);
      try {
        window.sessionStorage.removeItem(STORAGE_PENDING);
      } catch (error) {
        /* ignore */
      }
      var anchorHash = moduleAnchorHash(root);
      if (posted && window.location.hash !== anchorHash) {
        window.location.hash = anchorHash.slice(1);
      }
    }
    /*
      提交策略（2026-07-17 起）：Storefront 表单 Captcha 已在后台关闭，
      因此校验通过后用 fetch 就地 POST /contact，成功后原地显示横幅——
      不再整页跳转，消灭"提交后闪跳回顶部 Banner"（重页面 + 底部锚点，
      浏览器要到 DOMContentLoaded 才执行 #subscribe 锚定，期间停在页顶约 4 秒）。
      保险丝：若响应被 302 到 /challenge（说明有人重新开启了 Captcha），
      回退为原生 form.submit() 走整页 challenge 流程，行为与旧版一致。
    */
    var submitting = false;
    function markPending(email) {
      try {
        window.sessionStorage.setItem(STORAGE_PENDING, email.toLowerCase());
      } catch (error) {
        /* ignore */
      }
    }
    function showInPlaceSuccess(email) {
      var normalized = email.trim().toLowerCase();
      var wasKnown = isKnownEmail(normalized);
      showSuccess(wasKnown ? duplicateText : successText);
      rememberKnownEmail(normalized);
      setLoading(false);
      try {
        window.sessionStorage.removeItem(STORAGE_PENDING);
      } catch (error) {
        /* ignore */
      }
      /* URL 补上成功参数，刷新后 Liquid/JS 仍能还原成功态；replaceState 不触发滚动 */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('customer_posted', 'true');
        url.hash = moduleAnchorHash(root).slice(1);
        window.history.replaceState(null, '', url.toString());
      } catch (error) {
        /* ignore */
      }
    }
    function fallbackNativeSubmit() {
      /* form.submit() 不触发 submit 事件，不会再被本监听器或 Captcha 钩子拦截；
         无 token 的 POST 会被 Shopify 302 到整页 /challenge，即旧版原生流程 */
      submitting = false;
      form.submit();
    }
    function ajaxSubmit(email) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () { controller.abort(); }, 12000)
        : null;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { Accept: 'text/html' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (timer) clearTimeout(timer);
          var finalUrl = response.url || '';
          if (finalUrl.indexOf('/challenge') !== -1) {
            /* Captcha 被重新开启：交还原生整页流程 */
            fallbackNativeSubmit();
            return;
          }
          if (finalUrl.indexOf('customer_posted=true') !== -1) {
            submitting = false;
            showInPlaceSuccess(email);
            return;
          }
          /* 非预期落点（服务端校验失败等罕见情况）：交还原生流程兜底 */
          fallbackNativeSubmit();
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          fallbackNativeSubmit();
        });
    }
    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;
        /* 捕获阶段先于任何其他钩子；本监听器全权接管这次提交 */
        event.preventDefault();
        event.stopPropagation();
        if (submitting) return;
        var email = emailInput.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showInvalidEmail();
          emailInput.focus();
          return;
        }
        // 未勾选同意条款：给横幅提示并 focus（只 focus 不提示的话，用户会以为按钮坏了）
        if (consentCheckbox && !consentCheckbox.checked) {
          showError(consentRequiredText);
          consentCheckbox.focus();
          return;
        }
        /* 已订阅过的邮箱也照常提交（Shopify 对重复邮箱按成功处理），
           known-emails 只用于选择"重复订阅"文案，不拦截真实提交。 */
        markPending(email);
        submitting = true;
        setLoading(true);
        ajaxSubmit(email);
      },
      true
    );
    /* 从 /challenge 按返回键回来时页面走 bfcache，重置卡住的 loading/submitting 态 */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        submitting = false;
        setLoading(false);
      }
    });
    applyPostRedirectState();
  }
  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(
      container.querySelectorAll('[data-comu-subscribe-module]'),
      initSubscribeModule
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();